import React from 'react'
import ContentStyle from './ContentStyle/ContentStyle'

const Content = ({children}) => (
    <ContentStyle>
        {children}
    </ContentStyle>
)

export default Content